//this util check if opening hours are complete

import { isEmpty, map, reduce } from 'lodash'
import { sortDays } from './sortDays'

const daysOfWeek = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export const transformOpeningDays = (days) => {
  const completedDaysOfRequireDisabledKey = reduce(
    days,
    (res, day, index) => {
      if (
        isEmpty(day.disabled) &&
        !isEmpty(day.startTime) &&
        !isEmpty(day.endTime)
      ) {
        return {
          ...res,
          [index]: {
            ...day,
            disabled: false,
          },
        }
      } else if (isEmpty(day.disabled)) {
        return {
          ...res,
          [index]: {
            ...day,
            disabled: true,
          },
        }
      } else {
        return day
      }
    },
    {}
  )

  const providedDays = Object.keys(completedDaysOfRequireDisabledKey)

  const missingDays = daysOfWeek.filter(
    (day) => !providedDays.includes(day)
  )

  const missingDaysData = missingDays.reduce((res, day) => {
    return {
      ...res,
      [day]: {
        startTime: '',
        endTime: '',
        disabled: true,
        type: 'business_hours',
      },
    }
  }, {})

  const completeDaysData = {
    ...completedDaysOfRequireDisabledKey,
    ...missingDaysData,
  }

  const sortedCompletedDaysData = sortDays(completeDaysData)

  return sortedCompletedDaysData
}
